import { CircleAlert, RefreshCw } from "lucide-react";

import "./InlineLoadError.css";

export type InlineLoadErrorProps = {
  title: string;
  message: string;
  onRetry: () => void;
  retryLabel?: string;
  isRetrying?: boolean;
};

export function InlineLoadError({
  title,
  message,
  onRetry,
  retryLabel = "Tentar novamente",
  isRetrying = false,
}: InlineLoadErrorProps) {
  return (
    <div className="inline-load-error" role="alert">
      <span className="inline-load-error__icon" aria-hidden="true">
        <CircleAlert size={18} strokeWidth={2} />
      </span>
      <div className="inline-load-error__copy">
        <p className="inline-load-error__title">{title}</p>
        <p className="inline-load-error__message">{message}</p>
      </div>
      <button
        type="button"
        className="inline-load-error__retry"
        onClick={onRetry}
        disabled={isRetrying}
        aria-busy={isRetrying || undefined}
      >
        <RefreshCw
          size={15}
          strokeWidth={2}
          aria-hidden="true"
          className={isRetrying ? "is-spinning" : undefined}
        />
        {retryLabel}
      </button>
    </div>
  );
}
